import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Branch from 'branch-sdk';

Branch.init('key_live_diB8lUXePM5xrzYp3vmb1chmEraDDok0', function(err, data) {
    console.log('branch initialized');
    ReactDOM.render(<App branchData={data}/>, document.getElementById('root'));
}); 
    
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js